import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "./InquiryReply.css";
import FormFieldValidationError from '../../Common/FormFieldValidationError/FormFieldValidationError';
import FileAttachment from "./FileAttachment/FileAttachment";
import InquiryReplyTitleBar from "./InquiryReplyTitleBar";
import axios from "axios";
import {GOOGLE_ANALYTICS_CODE, RESOURCE_BASE_URL} from "../../../configuration";
import Redirect from "react-router-dom/es/Redirect";
import Modal from "react-bootstrap/es/Modal";
import ShowMoreText from "react-show-more-text";
import ReactGA from "react-ga";


class InquiryReply extends Component {

    constructor(props) {
        super(props);
        let today = new Date(),
            date = today.getFullYear() + ' -' + (today.getMonth() + 1) + ' -' + today.getDate();

        this.state = {
            email: "",
            subject: "",
            inquiry: "",
            reply: "",
            replyError: "",
            date: date,
            redirect: false,
            show : false,
            showError : false

        };

        this.onInputChange = this.onInputChange.bind(this);
        this.validateReply = this.validateReply.bind(this);
        this.saveReply = this.saveReply.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.handleShowError = this.handleShowError.bind(this);
        this.handleCloseError = this.handleCloseError.bind(this);

    }
    handleClose = () => {
        this.setState({
            show : false,
            redirect : true
        })
    };

    handleShow = () => {
        this.setState({
            show : true
        })
    };

    handleShowError = () => {
        this.setState({showError:true})
    };

    handleCloseError = () => {
        this.setState({
            showError : false,
        })
    };

    validateReply = () => {
        let reply = this.state.reply;
        return (reply !== "");
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            replyError: ""
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
        }
    }

    componentDidMount() {
        axios.get(RESOURCE_BASE_URL + 'api/users/inquiries/' + this.props.match.params.id)
            .then((res) => {
                this.setState({
                    email: res.data.email,
                    subject: res.data.subject,
                    inquiry: res.data.message
                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }


    saveReply = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };
        let resourceUrl = RESOURCE_BASE_URL + 'api/inquiries/' + this.props.match.params.id + '/reply';
        // console.log(resourceUrl, this.state.reply, this.props.userId);
        axios.post(resourceUrl
            , {
                reply: this.state.reply,
                repliedByAdminId: localStorage.getItem("userId"),
                inquiryId: this.props.match.params.id,
                isFromAdmin: 1
            }, axiosConfig)
            .then((res) => {
                // console.log("New reply saved", res);
                this.setState({ show : true});

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({showError:true});
            });

    };

    onSubmit = (event) => {
        event.preventDefault();
        let replyError = "";
        let validationPassed = true;

        if (!this.validateReply(event)) {
            validationPassed = false;
            replyError = "app.validation.inquiry-reply.invalid-reply";
        }

        if (validationPassed) {
            // console.log("Validation passed");
            this.saveReply();
        } else {

            this.setState({replyError});
        }
    };

    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);

        const {redirect} = this.state;

        if (redirect) {
            return <Redirect to='/admin/inquiries/viewAll'/>;
        }

        return (
            <div className="inquiry-reply-content">
                <div className="inquiry-reply-div">
                    <form onSubmit={this.onSubmit}>

                        <InquiryReplyTitleBar email={this.state.email} date={this.state.date}/>

                        <hr/>

                        <div className="row">
                            <div className="inquiry-reply-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.inquiry-reply.subject"
                                                              defaultMessage="Subject"
                                                              description=""/>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left ">
                                    <input type="text"
                                           className="form-control input-sm"
                                           name="subject"
                                           disabled={true}
                                           value={this.state.subject}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="inquiry-reply-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.inquiry-reply.inquiry"
                                                              defaultMessage="Inquiry"
                                                              description=""/>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">

                                    <ShowMoreText
                                        lines={3}
                                        more='詳細……'
                                        less='閉じる……'
                                        anchorClass=''
                                    >
                                        {this.state.inquiry}
                                    </ShowMoreText>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="inquiry-reply-row-margin">
                                <div className="col-md-2">
                                    <div className="text-right">
                                        <label>
                                            <FormattedMessage id="app.inquiry-reply.reply"
                                                              defaultMessage="Reply"
                                                              description=""/>
                                        </label>
                                    </div>
                                </div>
                                <div className="col-md-10 no-padding-left">
                                    <textarea type="text"
                                              className="form-control"
                                              name="reply"
                                              value={this.state.reply}
                                              onChange={this.onInputChange}
                                              rows={5}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-2">
                                <FormFieldValidationError errors={this.state.replyError}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="inquiry-reply-row-margin">
                                <div className="col-md-2"></div>

                                {/*<FileAttachment/>*/}
                                <div className="col-md-4 text-right">
                                    <button className="btn btn-primary" type="submit">
                                        <FormattedMessage id="app.inquiry-reply.button"
                                                          defaultMessage="Reply"
                                                          description=""/>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <Modal dialogClassName="message-modal" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.inquiry-reply.inquiry-success"
                                              defaultMessage="Success"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-8 data-label">

                                   <FormattedMessage id="app.inquiry-reply.inquiry-sent"
                                                      defaultMessage="Reply sent successfully"
                                                      description=""/>

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleClose}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal dialogClassName="message-modal" show={this.state.showError} onHide={this.handleCloseError}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.inquiry-reply.inquiry-error"
                                              defaultMessage="Error"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-offset-1 data-label">

                                    <FormattedMessage id="app.inquiry-reply.inquiry-not-sent"
                                                      defaultMessage="Error occurred while sending the reply mail to user"
                                                      description=""/>

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleCloseError}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default InquiryReply;



// WEBPACK FOOTER //
// ./src/components/Admin/InquiryReply/InquiryReply.js